import apiService from './apiService';
import { apiServiceRTQ } from './apiShow';

/**
 * Provides functions to fetch data by ID from the server.
 */
export const ShowDataById = {
  /**
   * Fetches data from the given URL by ID.
   *
   * @param {string} url - The URL to fetch data from.
   * @returns {Promise<Object>} A promise that resolves to the fetched data.
   */
  getDataById: async (url) => {
    return await apiServiceRTQ.get(url);
  },
};
